import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import {
	ButtonLink,
	ButtonLinkMenu,
	ImageAvatar,
	SquareChip,
	TagsArray,
	Text,
	useSettings,
	Icon
} from 'app/main/components';
import buttons from './PeopleButtons';

export default function PeopleListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const isSuspended = [2, 3].includes(props.model.peop_pest_id);

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="people"
			uid={props.model.peop_uid}
			avatar={props.model.peop_avatar}
			initials={props.model.peop_title_initials}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 600 ? 6 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.peop_warning_desc && (
								<Tooltip title={props.model.peop_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.peop_blocked_desc && (
								<Tooltip title={props.model.peop_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* SUSPENDED */}
							{isSuspended && (
								<Tooltip title={props.model.pest_title} arrow>
									<Icon className="mr-2" icon="person-off" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'people', uid: props.model.peop_uid }}
							>
								{props.model.peop_title}
							</Text>
						</Grid>
						{/* COMPANY */}
						<Grid size={12}>
							<ButtonLink
								href={`/companies/details/${props.model.peop_comp_uid}`}
								icon="domain"
								fallback={t('VIEW_ITEM_NO_COMPANY')}
							>
								{props.model.comp_title}
							</ButtonLink>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={props.width >= 960 ? 3 : props.width >= 600 ? 6 : 12}>
					<Grid container>
						{/* MAILS */}
						<Grid size={12}>
							<ButtonLinkMenu
								module="mails"
								list={props.model.peop_mails}
								table="people"
								href={item => `mailto:${item.mail_title}`}
								fallback={t('VIEW_ITEM_NO_MAIL')}
							/>
						</Grid>
						{/* PHONES */}
						<Grid size={12}>
							<ButtonLinkMenu
								module="phones"
								list={props.model.peop_phones}
								table="people"
								href={item => `tel:${item.phon_title}`}
								fallback={t('VIEW_ITEM_NO_PHONE')}
							/>
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 960 && (
					<Grid size={3}>
						{/* TYPE */}
						{props.model.pety_title && (
							<SquareChip label={props.model.pety_title} backgroundColor={props.model.pety_color} />
						)}
						{/* TAGS */}
						<TagsArray tags={props.model.peop_tags} changeFilter={props.changeFilter} />
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
